changeDefaultSelected()
checkFilters()
checkUrl()

// Remove 'all categories & make the next category option selected
function changeDefaultSelected () {
	const categoryOptions = document.querySelectorAll('.sf-field-taxonomy-downloadcategory ul li')
	
	categoryOptions[0].remove()	

	if (!window.location.href.includes('?')) {
		var highestInput = categoryOptions[1].childNodes[0]
		highestInput.checked = true
		
		window.location = `${window.location.protocol}//${window.location.host}/downloads/?_sft_downloadcategory=${highestInput.value}`
	}
}

// Check if the selected category has filters, if that isn't the case remove them.
function checkFilters () {
	const filters = document.querySelectorAll('.searchandfilter ul li[data-sf-field-type=taxonomy]')
	
	filters.forEach((filter, i) => {
		if (i !== 0) {
			let filterOptions = filter.childNodes[2].childNodes
			
			if (filterOptions.length <= 3) {
				filter.remove()
			}
		}
	})
}

// Check if the url has parameters that shouldn't be included
function checkUrl () {
	const radioLabels = document.querySelectorAll('.sf-field-taxonomy-downloadcategory ul li label')
	
	radioLabels.forEach(label => {
		label.addEventListener('click', e => {
			e.preventDefault()
			
			let clickedCategory = e.target.parentElement.childNodes[0].value				
			const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?_sft_downloadcategory=${clickedCategory}`

			window.location.href = newUrl
		})
	})
}

// Details popup
jQuery(document).ready(function ($) {
	const infoIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 65 65" style="enable-background:new 0 0 65 65;" xml:space="preserve" width="512px" height="512px"><g><g>
	<g>
		<path d="M32.5,0C14.58,0,0,14.579,0,32.5S14.58,65,32.5,65S65,50.421,65,32.5S50.42,0,32.5,0z M32.5,61C16.785,61,4,48.215,4,32.5    S16.785,4,32.5,4S61,16.785,61,32.5S48.215,61,32.5,61z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#004ED0"></path>
		<circle cx="33.018" cy="19.541" r="3.345" data-original="#000000" class="active-path" data-old_color="#000000" fill="#004ED0"></circle>
		<path d="M32.137,28.342c-1.104,0-2,0.896-2,2v17c0,1.104,0.896,2,2,2s2-0.896,2-2v-17C34.137,29.237,33.241,28.342,32.137,28.342z    " data-original="#000000" class="active-path" data-old_color="#000000" fill="#004ED0"></path>
	</g>
</g></g> </svg>`

    $('#download__details-popup').dialog({
	    autoOpen: false,
		modal: true,
		height: 700,
		maxWidth: 700,
		title: 'Details',
		draggable: false,
		resizable: false,
    })
    
	$('.download__details').click(e => {
		$('#download__details-content-holder').html(e.target.dataset.details)
		
		$('#download__details-popup').dialog('open')
		
		$('.ui-widget-overlay').click(() => {
			$( "#download__details-popup" ).dialog('close')
		})
	})
})
